import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router'
import { ArrowRight, MapPin } from 'lucide-react'

interface InlineLeadCaptureProps {
  service?: string
  heading?: string
  subheading?: string
}

export function InlineLeadCapture({
  service,
  heading = 'Recevez 3 devis gratuits sous 48h',
  subheading = 'Entrez votre code postal pour démarrer',
}: InlineLeadCaptureProps) {
  const [postal, setPostal] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!/^\d{5}$/.test(postal)) {
      setError('Code postal à 5 chiffres')
      return
    }
    const params = new URLSearchParams({ cp: postal })
    if (service) params.set('service', service)
    navigate(`/devis-gratuit?${params.toString()}`)
  }

  return (
    <form
      onSubmit={onSubmit}
      className="mx-auto max-w-2xl rounded-3xl border border-primary/20 bg-gradient-to-br from-primary-50 to-white p-6 shadow-sm sm:p-8"
    >
      <h2 className="text-center text-xl font-bold text-slate-900 sm:text-2xl">{heading}</h2>
      <p className="mt-1 text-center text-sm text-slate-600">{subheading}</p>
      <div className="mt-5 flex flex-col gap-3 sm:flex-row">
        <div className="relative flex-1">
          <MapPin className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            inputMode="numeric"
            maxLength={5}
            pattern="[0-9]{5}"
            value={postal}
            onChange={(e) => {
              setPostal(e.target.value.replace(/\D/g, ''))
              setError('')
            }}
            placeholder="Votre code postal"
            aria-label="Code postal"
            className="w-full rounded-xl border-2 border-slate-200 py-3.5 pl-12 pr-4 text-base font-medium text-slate-900 placeholder:text-slate-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
          />
        </div>
        <button
          type="submit"
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-hover btn-press"
        >
          Comparer 3 devis <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      {error && <p className="mt-2 text-center text-xs text-red-600">{error}</p>}
      <p className="mt-3 text-center text-xs text-slate-500">100 % gratuit · sans engagement · artisans vérifiés</p>
    </form>
  )
}
